"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_service_1 = require("src/app/Services/service.service");
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var is_mobile_1 = require("is-mobile");
var environment_1 = require("src/environments/environment");
var EnterDialogComponent = /** @class */ (function () {
    function EnterDialogComponent(dialogRef, data, router, service) {
        var _this = this;
        this.dialogRef = dialogRef;
        this.data = data;
        this.router = router;
        this.service = service;
        this.logo = document.createElement('img');
        this.isMobile = false;
        this.dialogRef.addPanelClass("enter-dialog-backdrop");
        if (is_mobile_1.default() || environment_1.environment.name == "CORDOVA") {
            this.isMobile = true;
        }
        this.subscription = this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                document.body.classList.remove("js-loader-active", "blacked");
                if (_this.loaderBody)
                    _this.loaderBody.remove();
                _this.subscription.unsubscribe();
            }
        });
    }
    EnterDialogComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.logo.addEventListener('load', function (event) {
            _this.service.disclaimerIsReady = true;
        });
    };
    EnterDialogComponent.prototype.ngOnInit = function () {
        document.body.classList.add("js-loader-active");
        if (!this.isMobile) {
            this.logo.src = 'assets/img/disclaimer_bg.jpg';
        }
        else {
            this.logo.src = 'assets/img/disclaimer_mobile.png';
        }
    };
    EnterDialogComponent.prototype.onOver18 = function () {
        //document.body.classList.add("js-loader-active", "blacked");
        this.service.Over18Years = true;
        if (!this.service.aplicationIsReady)
            this.loaderBody.classList.remove("hidden");
        this.dialogRef.close(true);
    };
    return EnterDialogComponent;
}());
exports.EnterDialogComponent = EnterDialogComponent;
